import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonSessionModel extends ModeModelBase {
  override _name = 'pythonSession';
  override belongsTo = 'pythonNotebook';
  override idAttribute = 'token';
  override hasOne = [{ name: 'reportRun', as: 'lastLoadedRun', idAttribute: 'token' }];
  override attributes = [
    { name: 'active', default: false },
    { name: 'termination_reason', default: '' },
  ];
}

@Injectable({ providedIn: 'root' })
export class PythonSessionModelAccessor extends ModelAccessorBase<PythonSessionModel> {
  override name = 'pythonSession';
  override idAttribute = 'token';
  override parentModel = 'pythonNotebook';
  override getIdFromLink = (link) => {
    return link.split('?')[0];
  };
  createModel(resource, opts?) {
    const model = new PythonSessionModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonSession');
  }
}
